'use client';
import { MobileTitle } from '@/components/title';
import { DotPage } from '@ssv-website/web-ui';
import { useRouter } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';

const RegenerateGoose = () => {
  const [current, setCurrent] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const cardWidthRef = useRef(0);
  const { push } = useRouter();
  const renderList = [
    {
      title: '再生个鹅',
      bgUrl:
        'https://cdn-digital.ssv.qq.com/upload//steelSlagGoose/m_home_goose_banner01.png',
      jumpUrl: '/steel-slag-goose',
    },
    {
      title: '敬请期待',
      bgUrl:
        'https://cdn-digital.ssv.qq.com/upload//steelSlagGoose/m_home_goose_banner02.png',
      jumpUrl: '',
    },
  ];

  useEffect(() => {
    if (!ref.current) return;

    const handleScroll = () => {
      const scrollLeft = ref.current?.scrollLeft || 0;
      const cardWidth = cardWidthRef.current || 0;

      if (cardWidth === 0) return; // 避免除以0

      const active = Math.round(scrollLeft / cardWidth);

      const validActive = Math.max(0, Math.min(active, renderList.length - 1));

      if (validActive !== current) {
        setCurrent(validActive);
      }
    };

    const scrollContainer = ref.current;
    scrollContainer.addEventListener('scroll', handleScroll);
    return () => scrollContainer.removeEventListener('scroll', handleScroll);
  }, [current, renderList.length]);

  const onHandleBannerClick = (url: string) => {
    if (url.includes('http')) {
      window.open(url);
    } else {
      push(url);
    }
  };

  return (
    <>
      <MobileTitle title="再生个鹅" style={{ fontFamily: 'TencentSansW7' }} />
      <div
        className="w-full flex overflow-x-auto hide-scrollbar snap-x snap-mandatory px-5 py-3"
        ref={ref}
      >
        {renderList.map((v, i) => (
          <div
            key={i}
            ref={(el) => {
              if (i === 0) {
                cardWidthRef.current = el?.offsetWidth ?? 0;
              }
            }}
            className="bannerItem flex-shrink-0 snap-always snap-center mr-[9.5px] last:mr-0 "
            onClick={() => onHandleBannerClick(v.jumpUrl)}
            style={{ width: '307px', height: '150px' }}
          >
            <div
              className="w-full h-[150px] rounded-2xl shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]"
              style={{
                background: `url(${v.bgUrl}) no-repeat right center / cover`,
              }}
            ></div>
          </div>
        ))}
      </div>
      <div className="mt-4">
        <DotPage current={current} total={renderList?.length} />
      </div>
    </>
  );
};

export default RegenerateGoose;
